import { useQuery } from '@tanstack/react-query';

import { ServiceProvider } from 'src/features/serviceProvider/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/service-provider/:providerId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    providerId: string;
    parkingId: string;
}
const queryFn = ({ providerId, parkingId }: DTO): Promise<ServiceProvider> => {
    return axios.get(formatResourcePath(RESOURCE, { providerId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetServiceProvider };
